import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { SFDataGrid, SFLoadingBar, SFEmptyPlaceholder } from "@sf-core";
import { GRID_NAMES } from "../../../../constants/gridNames";
import SFMatchRenderer from "../../components/renderers/matchRenderer";
import ClickCellRenderer from "../../components/renderers/clickCellRenderer";
import ProgressDialogs from "../../components/progressDialogs";
import { PROGRESS_TYPES } from "../../../../constants/progressTypes";

const MyJobsOfInterest = ({ items }) => {
  const [dialog, setDialog] = useState({ jobId: null, open: false });
  const { t } = useTranslation();
  const myJobsColumnDefs = useMemo(
    () => [
      {
        field: "jobName",
        headerName: " ",
        cellRenderer: "ClickCellRenderer",
        cellRendererParams: {
          onClick: (data) => {
            setDialog({
              jobId: data.jobRoleId,
              open: true,
              type: PROGRESS_TYPES.JOB_GOAL,
            });
          },
        },
        suppressRowClickSelection: true,
      },
      {
        field: "percentageMatch",
        headerName: t(
          "dashboardScreen.jobsOfInterestGridColumns.percentageMatch"
        ),
        cellRenderer: "SFMatchRenderer",
        cellClass: "proficiency-bar",
        minWidth: 150,
        maxWidth: 150,
        sortable: true,
        sortingOrder: ["desc", "asc"],
        sort: "desc",
        initialSortIndex: 1,
      },
    ],
    []
  );

  if (items.loading) return <SFLoadingBar />;

  if (!items.loading && items.data?.length === 0) return <SFEmptyPlaceholder />;

  return (
    <>
      {dialog?.open && (
        <ProgressDialogs dialog={dialog} setDialog={setDialog} />
      )}
      <SFDataGrid
        rowModelType="clientSide"
        gridName={GRID_NAMES.DASHBOARD_JOBS_OF_INTEREST}
        customComponents={{
          SFMatchRenderer,
          ClickCellRenderer,
        }}
        transparent
        noCardBorder
        disableBasicToolBar
        columnDefs={myJobsColumnDefs}
        rowData={items.data}
        persistState={false}
      />
    </>
  );
};
export default MyJobsOfInterest;
